"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TabsList = void 0;
var react_1 = __importDefault(require("react"));
var Container_1 = require("../Container/Container");
var TabsContext_1 = require("./TabsContext");
var TabsList = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    var _b = TabsContext_1.useTabsContext(), vertical = _b.vertical, currentIndex = _b.currentIndex, changeIndex = _b.changeIndex;
    var count = react_1["default"].Children.count(children);
    var BEFORE = vertical ? 38 : 37;
    var AFTER = vertical ? 40 : 39;
    var onKeyDown = function (event) {
        var keyCode = event.keyCode;
        if (keyCode === BEFORE) {
            event.preventDefault();
            changeIndex(((currentIndex || 0) - 1 + count) % count);
        }
        if (keyCode === AFTER) {
            event.preventDefault();
            changeIndex(((currentIndex || 0) + 1 + count) % count);
        }
    };
    return (react_1["default"].createElement(Container_1.Container, __assign({ role: "tablist", "aria-orientation": vertical ? 'vertical' : undefined, onKeyDown: onKeyDown, className: className }, rest), children));
};
exports.TabsList = TabsList;
//# sourceMappingURL=TabsList.js.map